module.exports = __webpack_public_path__ + "static/img/11.a762677.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/zh/11.png
// module id = ssst
// module chunks = 0